const MODAL = {
    onReady() {
        // Add a click event on buttons to open a specific modal
        (document.querySelectorAll('.js-modal-trigger') || []).forEach(trigger => {
            let modal  = trigger.dataset.target;
            let target = document.getElementById(modal);
            trigger.addEventListener('click', event => {
                event.preventDefault();
                MODAL.openModal({
                    node: target
                });
            });
        });
        // Add a click event on various child elements to close the parent modal
        (document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button.close') || []).forEach(close => {
            let target = close.closest('.modal');
            close.addEventListener('click', () => {
                MODAL.closeModal({
                    node: target
                });
            });
        });
        // Add a keyboard event to close all modals
        document.addEventListener('keydown', event => {
            let e = event || window.event;
            if (e.keyCode === 27) { // Escape key
                MODAL.closeAllModals();
            }
        });
        // Check if Modal gets called from URL
        let modal = location.hash.substring(1);
        if (document.getElementById(modal) == null) return;
        let target = document.getElementById(modal);
        if (!target.classList.contains('modal')) return;
        target.classList.add('is-active');
    },
    // Functions to open and close a modal
    openModal({node}) {
        node.classList.add('is-active');
    },
    closeModal({node}) {
        node.classList.remove('is-active');
        if (location.hash === '#'+node.id) {
            location.hash = ''; // Remove hash if modal is called over the URL
        }
    },
    closeAllModals() {
        (document.querySelectorAll('.modal') || []).forEach(modal => {
            MODAL.closeModal({
                node: modal
            });
        });
    }
}